import styled from "styled-components";
import {
    Typography,
} from "@mui/material";

import { BuyLicenseHeaderInterface } from '../../../Models/Common/CustomViewsInterfaces';

import { AssetImages } from '../../../Constants/Assets';

const BuyLicenseHeaderContainer: any = styled.div<{ }>`
    width: 100%;
    place-self: center;
    justify-items: center;
    overflow: unset !important;
    margin: 0px 0px 30px 0px;

    img {
        display: block;
        width: 100px;
        margin: 0px 0px 10px 0px;
    }

    .choosePlan {
        font-size: 22px;
        font-weight: 600;
    }

    .simplePrice {
        font-size: 15px;
        font-weight: 500;
        color: #878a99;
    }
`;

const BuyLicenseHeader = (props: BuyLicenseHeaderInterface) => {
    return <BuyLicenseHeaderContainer className="buyLicenseHeaderContainer">
        <img src={AssetImages.BUY_LICENSE_IMG} />
        <Typography className="choosePlan" color='primaryText'>{props?.headerTitle ?? "--"}</Typography>
        <Typography className="simplePrice">{props?.headerSubTitle ?? "--"}</Typography>
    </BuyLicenseHeaderContainer>
}

export default BuyLicenseHeader;